"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ExceptionPage_vue_1 = __importDefault(require("./view/ExceptionPage.vue"));
exports.default = (0, vue_1.defineComponent)({
    // eslint-disable-next-line vue/multi-word-component-names
    name: '403',
    components: {
        ExceptionPage: ExceptionPage_vue_1.default
    }
});
